import React, { useState } from "react";
import {
  signupAction,
  verifyUserAction,
} from "../../Services/Store/Actions/AuthActions";
import { isValidEmail, normalizeUsPhone, showToast } from "../../utils/helpers";
import { Link, useNavigate } from "react-router";
import CustomButton from "../../Components/Button";

import PhoneInput from "react-phone-input-2";
import { useDispatch } from "react-redux";
import { SignupRequestType } from "../../Constants/Interfaces";

import GoogleLoginBtn from "../../Components/GoogleLoginBtn";

interface SignupFormType {
  type?: "inline" | "modal";
  onSuccess?: Function | null;
  changeForm?: Function | null;
}

const SignupForm: React.FC<SignupFormType> = ({
  type = "inline",
  onSuccess = null,
  changeForm = null,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState<boolean>(false);
  const [signupSteps, setRegisterSteps] = useState<number>(1);

  const [data, setData] = useState<SignupRequestType>({
    name: "",
    email: "",
    phone: "",
    password: "",
  });
  const [veriCode, setVeriCode] = useState<string>("");
  const [verificationErr, setVeriErr] = useState<string>("");

  const [errors, setErrors] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
  });

  const onChange = (name: string, value: string) => {
    setData({
      ...data,
      [name]: value,
    });
  };

  const onCodeChange = (text: string) => {
    const numeric = text.replace(/[^0-9]/g, "");
    setVeriCode(numeric);
  };

  const validateForm = () => {
    let isError = false;

    const errs = {
      name: "",
      phone: "",
      email: "",
      password: "",
    };

    if (!data.name || data.name === "") {
      errs.name = "Please enter your name";
      isError = true;
    }
    if (!data.phone || data.phone === "") {
      errs.phone = "Please enter your phone";
      isError = true;
    }
    if (!data.email || data.email === "") {
      errs.email = "Please enter your email";
      isError = true;
    } else if (data.email && !isValidEmail(data.email)) {
      errs.email = "Please enter valid email";
      isError = true;
    }
    if (!data.password || data.password === "") {
      errs.password = "Please enter password";
      isError = true;
    }

    setErrors(errs);

    return isError;
  };

  const submitForm = () => {
    const isError = validateForm();

    if (!isError && !loading) {
      setLoading(true);

      signupAction(data)
        .then((res) => {
          if (res.type === "success") {
            setRegisterSteps(2);
            showToast("success", res.message);
          } else {
            showToast("error", res.message);
          }
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const verifyUserEmail = () => {
    let errs = "";
    let isErr = false;

    if (!veriCode || veriCode == "") {
      errs = "Please enter verification code";
      isErr = true;
    } else if (veriCode.length !== 6) {
      errs = "Please enter valid verification code";
      isErr = true;
    }

    setVeriErr(errs);

    if (!isErr) {
      setLoading(true);

      verifyUserAction({ email: data.email, otp: veriCode }, dispatch)
        .then((res) => {
          if (res.type === "success") {
            if (type === "inline") {
              redirectTo("/get-started");
            } else if (type === "modal" && onSuccess) {
              onSuccess();
            }
          }

          showToast(res.type, res.message);
        })
        .catch((err) => {
          showToast("error", err.message);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  };

  const redirectTo = (url: string) => {
    navigate(url);
  };

  return (
    <div className="auth-form-wrapper">
      <div className="auth-headings">
        <h3>Sign Up</h3>
        <p>
          By signing up, I agree to the spacii{" "}
          <Link to="#">Privacy Policy</Link> and{" "}
          <Link to="#">Terms of Service</Link>
        </p>
      </div>

      {signupSteps == 1 && (
        <>
          <div className="auth-form">
            <form
              method="post"
              onSubmit={(e) => {
                e.preventDefault();
                submitForm();
              }}
            >
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  className="form-control"
                  placeholder="Enter your name"
                  value={data.name}
                  onChange={(e) => onChange("name", e.target.value)}
                />
                {errors.name && errors.name !== "" && (
                  <span className="error">{errors.name}</span>
                )}
              </div>

              <div className="form-group">
                <PhoneInput
                  country={"us"}
                  onlyCountries={["us"]}
                  preferredCountries={["us"]}
                  value={data.phone}
                  onChange={(phone) =>
                    onChange("phone", normalizeUsPhone(phone))
                  }
                  containerClass="form-control form-phone-field"
                  placeholder="+1 (000) 000-0000"
                />
                {errors.phone && errors.phone !== "" && (
                  <span className="error">{errors.phone}</span>
                )}
              </div>

              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  className="form-control"
                  placeholder="Enter your email"
                  onChange={(e) => onChange("email", e.target.value)}
                />
                {errors.email && errors.email !== "" && (
                  <span className="error">{errors.email}</span>
                )}
              </div>

              <div className="form-group">
                <input
                  type="password"
                  name="password"
                  className="form-control"
                  placeholder="Enter password"
                  onChange={(e) => onChange("password", e.target.value)}
                />
                {errors.password && errors.password !== "" && (
                  <span className="error">{errors.password}</span>
                )}
              </div>

              <CustomButton
                title="Sign Up"
                isLoading={loading}
                onClick={submitForm}
              />
            </form>
          </div>

          <div className="login-with-or-text">
            <span>or</span>
          </div>

          <div className="social-login-btn-wrapper">
            <GoogleLoginBtn
              onSuccess={() => {
                if (type === "modal" && onSuccess) {
                  onSuccess();
                } else {
                  redirectTo("/get-started");
                }
              }}
            />
          </div>
        </>
      )}

      {signupSteps == 2 && (
        <div className="auth-form">
          <form
            method="post"
            onSubmit={(e) => {
              e.preventDefault();
              submitForm();
            }}
          >
            <div className="form-group">
              <input
                type="text"
                name="verification_code"
                className="form-control"
                placeholder="Enter verification code"
                value={veriCode}
                onChange={(e) => onCodeChange(e.target.value)}
                maxLength={6}
              />

              {verificationErr && verificationErr !== "" && (
                <span className="error">{verificationErr}</span>
              )}
            </div>

            <CustomButton
              title="Verify"
              isLoading={loading}
              onClick={verifyUserEmail}
            />
          </form>
        </div>
      )}

      <div className="have-an-account-links">
        <p>
          Already have an account?{" "}
          {type === "inline" && <Link to="/login">Login</Link>}{" "}
          {type === "modal" && changeForm && (
            <Link
              to="#"
              onClick={(e) => {
                e.preventDefault();
                changeForm("Login");
              }}
            >
              Login
            </Link>
          )}
        </p>
        <p>
          Question? Need help? <Link to="#">Support Can Help</Link>
        </p>
      </div>
    </div>
  );
};

export default SignupForm;
